"use strict";

var _toConsumableArray = require("C:\\ProgsVS2017\\fanals\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOptionalFactory = useOptionalFactory;

var _react = require("react");

function useOptionalFactory(arg, deps) {
  var memoDeps = _toConsumableArray(deps || []);

  if (deps == null && typeof arg !== 'function') {
    memoDeps.push(arg);
  }

  return (0, _react).useMemo(function () {
    return typeof arg === 'function' ? arg() : arg;
  }, memoDeps);
}